var module = angular.module('octopusApp.projects');

module.controller('StepTemplateDetailsController', function ($scope, busy, $stateParams, $location, octopusRepository, octopusPermissionSet, $filter, actionTemplateProcessor) {
    var isLoading = $scope.isLoading = busy.create();
    var isSaving = $scope.isSaving = busy.create();
    var source = $location.search().from;
    var projectId = source !== 'communityinstall' && source !== 'communityupdate' ? source : null;

    $location.search('activeTab', null); // Reset activeTab

    $scope.projectIdUrlFragment = '?from=' + source;
    $scope.templateId = $stateParams["id"];
    $scope.resolveLink = $filter('resolveLink');

    if (source === 'communityinstall') {
        $scope.cancelButtonName = 'Cancel';
        $scope.installButtonName = 'Install';
    } else if (source === 'communityupdate') {
        $scope.cancelButtonName = 'Cancel';
        $scope.updateButtonName = 'Update';
    }

    $scope.cancel = function() {
        $location.search("from", null);
        if (projectId ) {
            $location.path("/projects/" + projectId + "/steptemplates");
        } else if (source === 'communityinstall') {
            $location.path("/library/steptemplates/community/");
        } else {
            $location.path("/library/steptemplates/" + $scope.templateId).search("activeTab", "settings");
        }
    };

    $scope.redirectToActionTemplateEditor = function(actionTemplate) {
        if (projectId) {
            $location.path("/projects/" + source + "/process/step/new/" + actionTemplate.ActionType + "/" + actionTemplate.Id);
        }
        else if (source === 'communityinstall') {
            $location.path("/library/steptemplates/" + actionTemplate.Id);
        }
        else {
            $location.path("/library/steptemplates/" + actionTemplate.Id).search("activeTab", "usage");
        }
    };

    $scope.install = function() {
        return actionTemplateProcessor.installCommunityActionTemplate($scope.communityTemplate, $scope.redirectToActionTemplateEditor, false, isSaving);
    };

    $scope.update = function() {
        return actionTemplateProcessor.updateCommunityActionTemplateInstallation($scope.communityTemplate, $scope.redirectToActionTemplateEditor, isSaving);
    };

    if (projectId || source === 'communityinstall') {
        isLoading.promise(octopusRepository.CommunityActionTemplates.get($scope.templateId).then(function (communityTemplate) {

            $scope.communityTemplate = communityTemplate;
            isLoading.promise(octopusRepository.ActionTemplates.getByCommunityTemplate(communityTemplate)).then(function(actionTemplate){
                $scope.actionTemplate = actionTemplate;
                $scope.currentVersion = actionTemplate.Version;
            }).catch(function(error){
                if (error.StatusCode === 404) {
                    isLoading.clearError();
                } else {
                    throw error;
                }
            });
        }));
    }
    else {
        isLoading.promise(octopusRepository.ActionTemplates.get($scope.templateId)).then(function(actionTemplate){
            $scope.actionTemplate = actionTemplate;
            $scope.currentVersion = actionTemplate.Version;
            isLoading.promise(octopusRepository.CommunityActionTemplates.get(actionTemplate.CommunityActionTemplateId).then(function (communityTemplate) {
                $scope.communityTemplate = communityTemplate;
            }).catch(function(error){
                if (error.StatusCode === 404) {
                    isLoading.clearError();
                } else {
                    throw error;
                }
            }));

        });
    }


});






//////////////////
// WEBPACK FOOTER
// ./app/areas/library/steps/controllers/community_step_template_details_controller.js
// module id = 6401981460137404
// module chunks = 1